import React from "react";
import { Switch } from "react-router-dom";
import Zatca from "./zatca/Zatca";

function Integration() {
  return (
    <div>
      <Switch>
        <Zatca />
      </Switch>
    </div>
  );
}

export default Integration;
